import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import acceptedJobApi from '../../APIs/jobs';
import {
  Button,
  PageHeader,
  Pagination,
  Tag,
  Typography,
} from '../../designComponents';
import Table, { TableDataType } from '../../designComponents/Table';
import { COMPLETE_PDF_ROUTE } from '../../routes/routePaths';
import { requestAPI } from '../../utils';
import { PdfContainerStyled } from './style';

type Props = {};

type ParamsType = {
  page: number;
  limit: number;
};

const CompletePDF = (_props: Props) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
  });

  const getAllPDF = async () => {
    try {
      await requestAPI(acceptedJobApi.getAllPDF());
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllPDF();
  }, []);

  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
  };

  const handlePagination = (updatedParams: ParamsType) => {
    setParams(updatedParams);
  };

  const tableData: TableDataType = {
    headings: [
      { key: 'date', label: 'Complete Date' },
      { key: 'jobTitle', label: 'Job Title' },
      { key: 'buildingName', label: 'Building Name' },
      { key: 'createdBy', label: 'Created By' },
      { key: 'status', label: 'Status' },
      { key: 'actions', label: 'Action' },
    ],
    body: [
      {
        id: '1',
        date: '12 aug 2023 - 12:59 am',
        jobTitle: 'Evacuation plan for hotel',
        buildingName: 'Kathmandu Mall',
        createdBy: 'Chanda Shrestha',
        status: <Tag>Active</Tag>,
        actions: (
          <Button
            onClick={() => navigate(COMPLETE_PDF_ROUTE)}
            size="sm"
            variant="secondary"
          >
            Send to Client
          </Button>
        ),
      },
      {
        id: '2',
        date: '12 aug 2023 - 12:59 am',
        jobTitle: 'Evacuation plan for hotel',
        buildingName: 'Kathmandu Mall',
        createdBy: 'Chanda Shrestha',
        status: <Tag>Active</Tag>,
        actions: (
          <Button size="sm" variant="secondary">
            Send to Client
          </Button>
        ),
      },
    ],
  };

  return (
    <PdfContainerStyled>
      <PageHeader
        pageTitle={
          <Typography strong variant="title">
            Complete PDF
          </Typography>
        }
        search={search}
        handleOnSearchTextChange={handleOnSearchTextChange}
      />
      <div className="table-container">
        <Table tableData={tableData} />
      </div>
      <Pagination
        activePage={params.page}
        handlePagination={handlePagination}
        limit={params.limit}
        totalCount={136}
      />
    </PdfContainerStyled>
  );
};

export default CompletePDF;
